// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___VERm","col":"styles_col__2Tz7c","actions":"styles_actions__3ENV6","conflict":"styles_conflict__tKcUM"};